import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/Image/logo.svg";
import { useTranslation } from "react-i18next";
import { getLocalStoarge } from '../../../common/allfunction';
import Group1796 from "../../../../assets/Image/Group1796.svg";
import BRAIN_NEXT_ICONA from "../../../../assets/Image/BRAIN_NEXT_ICONA.svg";
{/**Tutorial Modal Image */ }
import TutorialModal from "../../../common/preAssessmentTutorialModal";
import HeaderIcon from "../../../../assets/Image/bw-executive-function-tutorial-pop-up-icon.svg";
import step1_it_img from "../../../../assets/Image/bw-executive-function-tutorial-pop-up-step-1.svg";
import step2_it_img from "../../../../assets/Image/bw-executive-function-tutorial-pop-up-step-2.svg";
import step1_en_img from "../../../../assets/Image/bw-executive-function-tutorial-pop-up-step-1_en.svg";
import step2_en_img from "../../../../assets/Image/bw-executive-function-tutorial-pop-up-step-2_en.svg";
import step3img from "../../../../assets/Image/bw-reaction-speed-tutorial-pop-up-step-3.svg";



export const ExecutiveFunctionIntro = (props) => {

    const [t, i18n] = useTranslation('common');
    const [btnText, setBtnText] = useState(`${t('user.steps.next')}`);
    // console.log("props", props)
    const component_id = props?.match?.params?.component_id;
    const repeat_time = props?.match?.params?.repeat_time;
    const day_sequence = props?.match?.params?.day_sequence;
    const activity_id = props?.match?.params?.activity_id;
    {/**Tutorial modal const */ }
    const [popupData, setPopupData] = useState({});
    const [modalIns1, setModalIns1] = useState(false);
    const [theme, setTheme] = useState(JSON.parse(localStorage.getItem("theme")));
    const [free, setFree] = useState(props?.match?.params?.free);

    useEffect(() => {
        document.body.className = (theme) ? theme : 'light';
    }, [theme])



    useEffect(() => {
        let lang = getLocalStoarge("langauage");
        if (lang) {
            i18n.changeLanguage(lang);
        }
        {/**Tutorial modal record */ }

        if (lang == "en") {
            var step1img = step1_en_img;
            var step2img = step2_en_img;
        } else {
            var step1img = step1_it_img;
            var step2img = step2_it_img;
        }
        let currentLink = !free ? `/executive-function/${component_id}/${repeat_time}/${day_sequence}/${activity_id}` : `/executive-function/${component_id}/${repeat_time}/${day_sequence}/${activity_id}/${free}`;
        let modalRecord = {
            modalHeading: t('user.activity.executive_function.intro_heading'),
            icon: HeaderIcon,
            step1text: t('user.activity.executive_function.step1text'),
            step1img: step1img,
            step2text: t('user.activity.executive_function.step2text'),
            step2img: step2img,
            step3text: t('user.activity.executive_function.step3text'),
            step3img: step3img,
            step4text: t('user.activity.executive_function.step4text'),
            startLink: currentLink
        };
        setPopupData({ ...modalRecord });
    }, [])

    const handleModal = () => {
        setModalIns1(false);
    }

    return (
        <>
            {(modalIns1) ? <TutorialModal popUpEnable={modalIns1} handleModal={handleModal} header={popupData} /> : null}
            <section className="steps-process steps-buttonchange reaction-speed-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="stepsin stpelog">
                            <Link to="/dashboard">
                                <img src={logo} className="logo-steps" alt="logo" />
                            </Link>
                        </div>
                        <div className="col-md-12 p-l-0">
                            <div className="tabControl" >
                                <div className="tab-content bgdarkfull" id="pills-tabContent">
                                    <div
                                        id="pills-1"
                                        role="tabpanel"
                                        aria-labelledby="pills-home-tab">
                                        <div className="reaction-mob">
                                            <div className="fl-xw  set-middlepart">
                                                <div className="row Topspace on-responsive reverse-d rew-full ipad-tmanage">
                                                    <div className="col-md-7 leftsteps">
                                                        <div className="pal-70">
                                                            <h2 className="steps-heading top-Align">
                                                                {t('user.activity.executive_function.intro_heading')}
                                                            </h2>
                                                            <p className="deskt-n" dangerouslySetInnerHTML={{ __html: t('user.activity.executive_function.intro_message') }}></p>
                                                            <p className="visi-none" dangerouslySetInnerHTML={{ __html: t('user.activity.executive_function.intro_message') }}></p>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5 text-center on-spacmob image-change-dark">
                                                        <img
                                                            src={Group1796}
                                                            className="img-fluid mang-imgi"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="btnNext-top">
                                                        <Link to={`/congnitive-training/${repeat_time}`}>
                                                            <button
                                                                className="btn btn-primary btnNext"
                                                            >
                                                                {t("user.activity.reaction_speed.back")}
                                                            </button>
                                                        </Link>

                                                    </div>
                                                </div>
                                            </div>
                                            <div id="btnNext">
                                                <div className="fit-bdots">
                                                    <ul
                                                        className="nav nav-pills nav-fill"
                                                        id="pills-tab"
                                                        role="tablist">
                                                        <li className="nav-item">
                                                            <a
                                                                onClick={() => changeDot(1)}
                                                                id="pills-home-tab"
                                                                data-toggle="pill"
                                                                href="#pills-1"
                                                                role="tab"
                                                                aria-controls="first"
                                                                aria-selected="true"
                                                            ></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* <span className="mob-bott" onClick={() => changeDot(4)}>
                                                    {t('user.steps.pg_1.text.nxtbtn')}
                                                </span> */}
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div>
                                                        <button className="remove-colorbtn cursor-pointer"
                                                            // className="btn btn-primary btnNext"
                                                            // onClick={nextpage}
                                                            onClick={() => setModalIns1(true)}
                                                        >
                                                            {t("user.activity.executive_function.see_tutorial")}
                                                        </button>

                                                        <img src={BRAIN_NEXT_ICONA} className="arrow-icons" alt="" />
                                                    </div>
                                                    {free ? 
                                                    <Link to={`/executive-function/${component_id}/${repeat_time}/${day_sequence}/${activity_id}/${free}`}>
                                                        <button
                                                            className="btn btn-primary btnNext"
                                                        // onClick={nextpage}
                                                        >
                                                            {t("user.activity.executive_function.start")}
                                                        </button>
                                                    </Link>
                                                    : <Link to={`/executive-function/${component_id}/${repeat_time}/${day_sequence}/${activity_id}`}>
                                                    <button
                                                        className="btn btn-primary btnNext"
                                                    // onClick={nextpage}
                                                    >
                                                        {t("user.activity.executive_function.start")}
                                                    </button>
                                                </Link>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

